import { FC } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Container } from './styles'
import { FlexDiv, OrangeButtonOutlined } from '../index'
import { FirmSearchListData } from 'src/dtos/portal'

interface FirmListRowProps {
  rowData: FirmSearchListData
}

const FirmListRow: FC<FirmListRowProps> = ({ rowData }) => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  const handleClickViewFirm = () => {
    navigate({
      pathname,
      search: `view=${rowData.firmId ?? 0}`
    })
  }
  
  return (
    <Container>
      <header>
        <FlexDiv align='center' gap="30px">
          <strong>{rowData.name}</strong>
          <h6>#{rowData.firmNumber}</h6>
        </FlexDiv>
        <OrangeButtonOutlined onClick={handleClickViewFirm}>
          View
        </OrangeButtonOutlined>
      </header>
      <section>
        <table>
          <thead>
            <tr>
              <th>Contact First Name</th>
              <th>Contact Last Name</th>
              <th>Email</th>
              <th>Policy #</th>
              <th>Quote #</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{rowData.adminFirstName}</td>
              <td>{rowData.adminLastName}</td>
              <td>{rowData.email}</td>
              <td>{rowData.policyNumber}</td>
              <td>{rowData.quoteNumber}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </Container>
  )
}

export default FirmListRow